import moment from 'moment';
import statesArray from '../../../app/utils/statesArray';
import roleArrayValidation from '../../../app/utils/roleArray';
import projectRequirementsArray from '../../../app/utils/projectRequirementsArray';
import { FormsList } from '../../../app/submissions/components/SelectForms';

const limitsforOIOptions = [
    {
        optionId: '1',
        text: 'No Excess',
        value: 'noExcess'
    },
    {
        optionId: '2',
        text: '$1,000,000',
        value: '1000000'
    },
    {
        optionId: '3',
        text: '$2,000,000',
        value: '2000000'
    },
    {
        optionId: '4',
        text: '$3,000,000',
        value: '3000000'
    },
    {
        optionId: '5',
        text: '$4,000,000',
        value: '4000000'
    },
    {
        optionId: '6',
        text: '$5,000,000',
        value: '5000000'
    },
    {
        optionId: '7',
        text: '$6,000,000',
        value: '6000000'
    },
    {
        optionId: '8',
        text: '$7,000,000',
        value: '7000000'
    },
    {
        optionId: '9',
        text: '$8,000,000',
        value: '8000000'
    },
    {
        optionId: '10',
        text: '$9,000,000',
        value: '9000000'
    },
    {
        optionId: '11',
        text: '$10,000,000',
        value: '10000000'
    },
];

const updatedData = {
    questionSetId: 'OIFORM',
    name: 'OIFORM',
    questions: [
        {
            questionId: 'label1',
            inputType: 'label',
            text: 'General Information',
            name: 'label1'
        },
        {
            questionId: '1',
            text: 'Applicant',
            name: 'primaryInsuredName',
            required: true,
            inputType: 'text',
            inputFormat: 'text',
            placeholder: 'This entity must be named as the Owner in the contract receiving hold harmless, indemnification and additional insured status from the hired General Contractor',
            placeholderHidden: false
        },
        {
            questionId: '2',
            name: 'primaryInsuredAddressLabel',
            text: "Mailing Address",
            inputFormat: 'label',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2a',
            name: 'primaryInsuredAddress',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'Address 1',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2aa',
            name: 'primaryInsuredAddress2',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: false,
            placeholder: 'Address Line 2',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '2b',
            name: 'primaryInsuredCity',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },

        {
            questionId: '2c',
            name: 'primaryInsuredState',
            inputType: 'dropdown-single',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            attributes: {
                options: statesArray,
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2d',
            name: 'primaryInsuredZipcode',
            inputType: 'text',
            inputFormat: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: '2e',
            name: 'primaryInsuredWebsite',
            inputType: 'text',
            inputFormat: 'text',
            tooltiptext: 'Please provide Website.',
            required: false,
            placeholder: 'Website',
            attributes: {
                controlGroup: 'insuredAddress'
            }
        },
        {
            questionId: 'label4',
            inputType: 'label',
            text: 'Project Details',
            name: 'label4'
        },
        {
            questionId: '26',
            name: 'projectName',
            text: 'Project Name?',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
        },
        {
            questionId: '6',
            name: 'projectAddressLabel',
            text: 'What is the address of the project?',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'projectAddress'
            },
            placeholder: 'This must be a single location, the policy is project specific',
            placeholderExposed: true
        },
        {
            questionId: '6a',
            name: 'projectAddress',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'Address 1',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },

        {
            questionId: '6aa',
            name: 'projectAddress2',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: false,
            placeholder: 'Address Line 2',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '6b',
            name: 'projectCity',
            inputFormat: 'text',
            inputType: 'text',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '6c',
            name: 'projectState',
            inputType: 'dropdown-single',
            tooltiptext: 'Please provide as descriptive of a street address as possible.',
            required: true,
            placeholder: 'State',
            attributes: {
                options: statesArray,
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '6d',
            name: 'projectZipcode',
            inputType: 'text',
            inputFormat: 'text',
            required: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '33',
            name: 'parcelId',
            text: 'Parcel ID',
            inputFormat: 'text',
            inputType: 'freeform',
            subHelper: `Underwriter will confirm clearance shortly`,
            subHelperTitle: `Please note: `,
            required: false,
            attributes: {
                controlGroup: 'projectAddress'
            }
        },
        {
            questionId: '25',
            name: 'populationDensity',
            text: 'Population Density?',
            inputType: 'dropdown-single',
            required: false,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Select',
                        value: ''
                    },
                    {
                        optionId: '2',
                        text: 'Urban',
                        value: 'Urban'
                    },
                    {
                        optionId: '3',
                        text: 'Suburban',
                        value: 'Suburban'
                    },
                    {
                        optionId: '4',
                        text: 'Rural',
                        value: 'Rural'
                    },
                ]

            }

        },
        {
            questionId: '7a',
            text: 'Effective date',
            name: 'anticipatedStartDate',
            required: true,
            inputType: 'text',
            inputFormat: 'date',
            helper:
                `Please provide the date as or before ${moment(Date.now() + 90 * 24 * 60 * 60 * 1000).format('MM/DD/YYYY')} (90 days)`,
            helper_uw:
                `Please provide the date between ${moment(Date.now() - 90 * 24 * 60 * 60 * 1000).format('MM/DD/YYYY')} and ${moment(Date.now() + 90 * 24 * 60 * 60 * 1000).format('MM/DD/YYYY')} (90 days back and future date)`
        },
        {
            questionId: '7b',
            text: 'Finish date',
            name: 'anticipatedFinishDate',
            required: true,
            inputType: 'text',
            inputFormat: 'date',
            helper: 'If this is unknown, then set to one year in advance.'
        },
        {
            questionId: '8',
            text: 'What are the total construction costs of this project?',
            name: 'totalCost',
            inputType: 'text',
            inputFormat: 'currency',
            required: true,
            helper: '*This is the exposure the quote will be rated on and is subject to audit.',
            placeholder:
                'Total Construction Value means the total cost of all work let or sublet including: a) the cost of all labor, materials and equipment furnished, used or delivered for use in the execution of the work and b) all fees bonuses or commissions made, paid or due.',
            placeholderHidden: true
        },
        {
            questionId: '29',
            name: 'contractNumber',
            text: 'Contract # (if known)',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
        },
        {
            questionId: '22',
            name: 'projectScope',
            text: 'Scope of Work',
            tooltiptext: 'Please be as descriptive as possible.',
            inputFormat: 'text',
            inputType: 'freeform',
            required: true,
            placeholder:
                'Provide as much detail as possible.',
            placeholderExposed: true
        },
        {
            questionId: '23',
            name: 'projectType',
            text: 'Project Type?',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Select',
                        value: '',
                    },
                    {
                        optionId: '2',
                        text: 'Industrial',
                        value: 'Industrial'

                    },
                    {
                        optionId: '3',
                        text: 'Residential',
                        value: 'Residential',
                        supplementalquestionIds: ['23_supplemental1']
                    },
                    {
                        optionId: '4',
                        text: 'Commercial',
                        value: 'Commercial'
                    },
                ]
            }

        },
        {
            questionId: '24',
            name: 'constructionSite',
            text: 'New or Remodel/Renovation or Demo only',
            inputType: 'dropdown-single',
            affectOtherField: 'squareFootagePercent',
            thirdLevelSupplementQuesId: ['label24'],
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Select',
                        value: ''
                    },
                    {
                        optionId: '2',
                        text: 'New',
                        value: 'New'
                    },
                    {
                        optionId: '3',
                        text: 'Remodel/Renovation',
                        value: 'Remodel/Renovation',
                        supplementalquestionIds: ['24_supplemental1']
                    },
                    {
                        optionId: '4',
                        text: 'Demo Only',
                        value: 'Demo Only'
                    },
                ],
            }
        },
        {
            questionId: '99',
            text: 'Total square footage of the finished project',
            name: 'squareFootage',
            required: false,
            inputType: 'text',
            inputFormat: 'text',
            attributes: {
                options: [
                    {
                        supplementalquestionIds: ['991']
                    },
                ]
            },
        },
        {
            questionId: '992',
            text: 'Number of stories of the finished project',
            name: 'storiesFinishedProject',
            required: false,
            inputType: 'number',
            inputFormat: 'number',
            placeholderHidden: true
        },
        {
            questionId: '3',
            text: 'Is project limited to specific floors?',
            name: 'specificFloors',
            inputType: 'radio',
            tooltiptext: 'Please choose if project is limited to specific floors.',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['3_supplemental1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ]
            }
        },
        {
            questionId: '330',
            text:
                'Does the project include any vertical expansion?',
            name: 'isVerticalExpansion',
            inputType: 'radio',
            placeholder: 'If this is a Ground Up Construction project, select No.',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['330_supplemental1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
         {
            questionId: '331',
            text:
                'Does the project include any horizontal expansion?',
            name: 'isHorizontalExpansion',
            inputType: 'radio',
            placeholder: 'If this is a Ground Up Construction project, select No.',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['331_supplemental1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '31',
            name: 'exteriorWorkFiveStories',
            text: 'Is there any exterior work being done over 5 stories?',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '993',
            text: 'Will any work be performed more than eight (8) feet below grade?',
            name: 'eightFeet',
            required: true,
            inputType: 'radio',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '994',
            text: 'Describe the intended end use of the building?',
            name: 'endUseOfBuilding',
            required: true,
            inputType: 'text',
            inputFormat: 'text',
            placeholderHidden: true
        },
        {
            questionId: '34',
            text:
                'Is any portion intended to be sold after project completion?',
            name: 'portionSold',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['34_supplemental1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '16',
            name: 'projectRequirements',
            text:
                'Does the project involve work related to any of the following: ',
            inputType: 'checkbox',
            required: true,
            attributes: {
                options: projectRequirementsArray()
            }
        },
        {
            questionId: '997',
            text: 'Does the project include any form of demolition?',
            name: 'exteriorDemo',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '997_supplemental1',
                            '997_supplemental2',
                            '997_supplemental3',
                            '997_supplemental4',
                            '997_supplemental5',
                            '997_supplemental6',
                            '997_supplemental7',
                            '997_supplemental8',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ]
            }
        },
        {
            questionId: '9',
            text: 'Will there be use of a tower crane on this project?',
            name: 'towerCraneUse',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            helper:
                'Tower Cranes are cranes that are fixed to the ground on a concrete slab (and sometimes attached to the sides of structures)',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '11',
            text: 'Will there be full or partial occupancy of any buildings during the Project?',
            name: 'occupancy',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '11_supplemental5',
                            '11_supplemental3',
                            '11_supplemental4',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '13',
            text: 'Has Work started on this project?',
            name: 'workStarted',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '13_supplemental1',
                            '13_supplemental5',
                            '13_supplemental6',
                            '13_supplemental7',
                            '13_supplemental4',
                            '13_supplemental8',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ]
            }
        },
        {
            questionId: '15',
            name: 'sidewalkMaintaining',
            text: 'Who is responsible for maintaining the site/ sidewalks (including snow/ice removal)?',
            inputType: 'dropdown-single',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Select',
                        value: ''
                    },
                    {
                        optionId: '2',
                        text: 'GC',
                        value: 'GC',
                        supplementalquestionIds: []
                    },
                    {
                        optionId: '3',
                        text: 'Owner',
                        value: 'Owner',
                        supplementalquestionIds: []
                    },
                    {
                        optionId: '4',
                        text: 'Other',
                        value: 'Other',
                        supplementalquestionIds: ['15_supplemental1']
                    }
                ]
            }
        },
        {
            questionId: 'label5',
            inputType: 'label',
            text: 'General Contractor',
            name: 'label5',
        },
        {
            questionId: '10',
            text: 'Is the General Contractor known?',
            name: 'generalContractorKnown',
            inputType: 'radio',
            tooltiptext:
                'Note: Coverage will be priced subject to form U658 until the General  Contractor is reviewed and approved.  To approve the General Contractor  we will need at a minimum, fully executed contract, certificate of insurance, and endorsement listing from the GC’s General Liability.',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            'label6',
                            '10_supplemental1',
                            '10_supplemental2',
                            '10_supplemental3',
                            '10_supplemental4'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ]
            }
        },
        {
            questionId: '998',
            text:
                'Is there any common ownership between the Owner and the General Contractor?',
            name: 'commonOwnership',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ],
            }
        },
        {
            questionId: '32',
            text:
                'Is the owner paying, contracting, or supervising any subcontractors other than the GC?',
            name: 'otherSubcontractorsPaid',
            inputFormat: 'radio',
            inputType: 'radio',
            helper: "Note our appetite for Owner's Interest is for 3 directly hired contractors. If the owner is hiring more than three contractors directly, this risk is ineligible.",
            helper2: "Note our Deductible Warranty Coverage Option is only available for risks where the Owner is only hiring one contractor directly.",
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['32_supplemental1']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ],
            }
        },
        {
            questionId: 'label999',
            inputType: 'label',
            text: 'Additional Named Insureds & Additional Insureds',
            name: 'label999',
            attributes: {
                controlGroup: ''
            }
        },
        {
            questionId: '4',
            text: 'Are there other requested Named Insureds for this project?',
            name: 'secondaryInsured',
            inputType: 'radio',
            placeholder:
                'Qualified entities must be named as the Owner in the contract receiving hold harmless, indemnification and additional insured status from the hired General Contractor',
            required: true,
            placeholderExposed: true,
            thirdLevelSupplementQuesId: ['16_supplemental4'],
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            'label2',
                            '4_supplemental1',
                            '4_supplemental2',
                            '4_supplemental3',
                            '4_supplemental4',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ],
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: '5',
            text: 'Are there any other requested Additional Insureds',
            name: 'additionalInsured',
            inputType: 'radio',
            helper: "*NOTE* Requests for Additional Insureds are NOT automatically granted; we require the below information to consider: ",
            placeholder:
                'AP is $250 per Named AI form. Qualified Additional Insureds must also be named an Additional Insured on the General Contractor’s General Liability to be approved. Entities (other than lenders) will require Underwriter review for further processing of quotes.',
            required: true,
            placeholderExposed: true,
            thirdLevelSupplementQuesId: ['7_supplemental1', '17_supplemental4', '18_supplemental2a'],
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            'label3',
                            '5_supplemental1',
                            '5_supplemental6',
                            '5_supplemental7',
                            '5_supplemental8',
                            '5_supplemental9',
                            '5_supplemental2',
                            '5_supplemental3',
                            '7_supplemental1',
                            '5_supplemental5',
                            '5_supplemental4'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ]
            }
        },

        {
            questionId: '17',
            name: 'generalComments',
            text: 'General Comments',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
            helper: 'Please provide any comments or assumptions to question responses'
        },
        {
            questionId: '67',
            name: 'auditorInformation',
            text: 'Audit Contact Information',
            inputFormat: 'label',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '67aa',
            name: 'auditorName',
            inputType: 'text',
            inputFormat: 'label',
            required: false,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '67bb',
            name: 'auditorEmail',
            inputType: 'text',
            inputFormat: 'label',
            required: false,
            placeholder: 'Email',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '67cc',
            name: 'auditorPhone',
            inputType: 'text',
            inputFormat: 'phone',
            required: false,
            placeholder: 'Phone number',
            attributes: {
                controlGroup: 'AuditorInfo'
            }
        },
        {
            questionId: '18',
            name: 'nameInsuredAddressLabel',
            text: 'Contact Information',
            inputFormat: 'label',
            title: 'Please provide your contact info to receive your quote',
            attributes: {
                controlGroup: 'contactInfo'
            }
        },
        {
            questionId: '18a',
            name: 'email',
            inputType: 'text',
            inputFormat: 'label',
            required: true,
            placeholder: 'Email',
            attributes: {
                controlGroup: 'contactInfo'
            }
        },
        {
            questionId: '18b',
            name: 'phone',
            inputType: 'text',
            inputFormat: 'phone',
            required: true,
            placeholder: 'Phone number',
            attributes: {
                controlGroup: 'contactInfo'
            }
        },
        {
            questionId: '14',
            text: 'Limits for excess coverage.',
            name: 'excessLimitAmount',
            title: 'Offer an Excess Quote',
            inputType: 'dropdown-single',
            additionalInfo1Color: '#417505',
            additionalInfoIcon: 'border_color',
            additionalInfo1: 'More options for your client',
            additionalInfo2:
                "Excess policies are follow form to Colony's General Liability policy and subject to the General Contractor having equal or greater limits.",
            required: true,
            attributes: {
                options: limitsforOIOptions,
                default: limitsforOIOptions,
                optional: [
                    {
                        optionId: '1',
                        text: 'No Excess',
                        value: 'noExcess'
                    },
                    {
                        optionId: '2',
                        text: '$1,000,000',
                        value: '1000000'
                    },
                    {
                        optionId: '3',
                        text: '$2,000,000',
                        value: '2000000'
                    },
                    {
                        optionId: '4',
                        text: '$3,000,000',
                        value: '3000000'
                    },
                    {
                        optionId: '5',
                        text: '$4,000,000',
                        value: '4000000'
                    },
                    {
                        optionId: '6',
                        text: '$5,000,000',
                        value: '5000000'
                    },
                    {
                        optionId: '7',
                        text: '$6,000,000',
                        value: '6000000'
                    },
                    {
                        optionId: '8',
                        text: '$7,000,000',
                        value: '7000000'
                    },
                    {
                        optionId: '9',
                        text: '$8,000,000',
                        value: '8000000'
                    },
                    {
                        optionId: '10',
                        text: '$9,000,000',
                        value: '9000000'
                    },
                    {
                        optionId: '11',
                        text: '$10,000,000',
                        value: '10000000'
                    }
                ]
            }
        }
    ],

    supplementalQuestions: [
        {
            questionId: '3_supplemental1',
            text: 'Please provide details',
            name: 'specificFloorsDetails',
            inputFormat: 'text',
            inputType: 'freeform',
            tooltiptext: 'Please choose if project is limited to specific floors.',
            required: false
        },
        {
            questionId: '991',
            text: 'If remodel/renovation, advise % of total building square footage that is being renovated',
            name: 'squareFootagePercent',
            required: false,
            inputType: 'text',
            inputFormat: 'text',
            placeholderHidden: true
        },
        {
            questionId: '330_supplemental1',
            text: 'Please provide details',
            name: 'verticalExpansionDetail',
            inputFormat: 'text',
            inputType: 'freeform',
            tooltiptext: 'Vertical Expansion',
            required: false
        },
        {
            questionId: '331_supplemental1',
            text: 'Please provide details',
            name: 'horizontalExpansionDetail',
            inputFormat: 'text',
            inputType: 'freeform',
            tooltiptext: 'Horizontal Expansion',
            required: false
        },
        {
            questionId: '34_supplemental1',
            text: 'What is the approximate sales price per unit/home/lot/total project?',
            name: 'portionSoldSales',
            inputFormat: 'text',
            inputType: 'freeform',
            tooltiptext: 'Portion Complition',
            required: false
        },
        {
            questionId: '23_supplemental1',
            text: 'Total # of units, lots, and or homes',
            name: 'residentials',
            inputFormat: 'text',
            inputType: 'freeform',
            tooltiptext: 'Residential',
            required: false
        },
        {
            questionId: '24_supplemental1',
            text: 'Will there be any structural work performed?',
            name: 'structuralWork',
            inputFormat: 'radio',
            inputType: 'radio',
            tooltiptext: 'structuralWork',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: ['label24']
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                    }
                ]
            }
        },
        {
            questionId: '4_supplemental1',
            name: 'secondaryNameInsuredName',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'secondaryNamedInfo'
            }
        },

        {
            questionId: '4_supplemental3',
            name: 'secondaryNameInsuredRelationship',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            placeholder: 'Relationship To Primary',
            attributes: {
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: 'label2',
            inputType: 'label',
            text: 'Named Insured Details',
            name: 'label2',
            attributes: {
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: '4_supplemental4',
            text: 'Any other Named Insured?',
            name: 'secondaryNameInsuredOther',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            thirdLevelSupplementQuesId: ['20_supplemental3'],
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '16_supplemental1',
                            '16_supplemental2',
                            '16_supplemental3',
                            '16_supplemental4'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ],
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: '16_supplemental1',
            name: 'secondSecondaryNameInsuredName',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: '16_supplemental3',
            name: 'secondSecondaryNameInsuredRelationship',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            placeholder: 'Relationship To Primary',
            attributes: {
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: '16_supplemental4',
            text: 'Any other Named Insured?',
            name: 'secondSecondaryNameInsuredOther',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '20_supplemental1',
                            '20_supplemental2',
                            '20_supplemental3',
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ],
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: '20_supplemental1',
            name: 'thirdSecondaryNameInsuredName',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'secondaryNamedInfo'
            }
        },
        {
            questionId: '20_supplemental3',
            name: 'thirdSecondaryNameInsuredRelationship',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            placeholder: 'Relationship To Primary',
            attributes: {
                controlGroup: 'secondaryNamedInfo'
            }
        },

        {
            questionId: '16_supplemental5',
            name: 'additionalInsuredAddress',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            helper: ' Note - Additional Insured address information is mandatory at the time of binding',
            placeholder: 'Address',
            attributes: {
                controlGroup: 'additionalNamedInsured'
            }
        },
        {
            questionId: '16_supplemental6',
            name: 'additionalInsuredCity',
            inputFormat: 'text',
            inputType: 'text',
            inlineItem: true,
            required: false,
            placeholder: 'City',
            attributes: {
                controlGroup: 'additionalNamedInsured'
            }
        },
        {
            questionId: '16_supplemental7',
            name: 'additionalInsuredState',
            inputType: 'dropdown-single',
            required: false,
            inlineItem: true,
            placeholder: 'State',
            attributes: {
                options: statesArray,
                controlGroup: 'additionalNamedInsured'
            }
        },
        {
            questionId: '16_supplemental8',
            name: 'additionalInsuredZipCode',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            inlineItemZip: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'additionalNamedInsured'
            }
        },

        {
            questionId: 'label24',
            inputType: 'freeform',
            text: 'Please provide all known details',
            name: 'StructuralWorkPerformedDetail',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'residential'
            }
        },
        {
            questionId: 'label3',
            inputType: 'label',
            text: 'Additional Insured Details',
            name: 'label3',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '5_supplemental1',
            name: 'additionalInsuredName',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '5_supplemental2',
            name: 'additionalInsuredRelationship',
            inputType: 'dropdown-single',
            required: true,
            inlineItem: true,
            containRelationForms: 'Forms1',
            placeholder: 'Relationship To Primary',
            attributes: {
                options: roleArrayValidation('18_supplemental2a'),
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '7_supplemental1',
            text: 'Does the lender need to be specifically named?',
            name: 'banksMortgagees',
            inputType: 'radio',
            placeholder:
                'Blanket CG2018 is included for lenders. AP is $250 per Named Bank form.',
            placeholderExposed: true,
            tooltiptext: 'Please choose if you need to name the bank.',
            required: true,
            hideKey: 'Forms1',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                    }
                ],
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '5_supplemental5',
            text: 'List all forms needed:',
            name: 'additionalInsuredForms',
            inputFormat: 'radio',
            inputType: 'dropdown-multiselectcheckbox',
            required: false,
            conditionalText: '*Condition to Underwriter Approval',
            formsList: 'Forms1',
            attributes: {
                options: FormsList,
                controlGroup: 'additionalInsuredInfo'
            },
        },
        {
            questionId: '5_supplemental6',
            name: 'additionalInsuredAddress',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            helper: ' Note - Additional Insured address information is mandatory at the time of binding',
            placeholder: 'Address',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '5_supplemental7',
            name: 'additionalInsuredCity',
            inputFormat: 'text',
            inputType: 'text',
            inlineItem: true,
            required: false,
            placeholder: 'City',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '5_supplemental8',
            name: 'additionalInsuredState',
            inputType: 'dropdown-single',
            required: false,
            inlineItem: true,
            placeholder: 'State',
            attributes: {
                options: statesArray,
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '5_supplemental9',
            name: 'additionalInsuredZipCode',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            inlineItemZip: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '5_supplemental4',
            text: 'Any other Additional Insured?',
            name: 'additionalInsuredOther',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            thirdLevelSupplementQuesId: ['7_a_supplemental2', '19_supplemental4', '14_supplemental2a'],
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '17_supplemental1',
                            '17_supplemental6',
                            '17_supplemental7',
                            '17_supplemental8',
                            '17_supplemental9',
                            '17_supplemental2',
                            '17_supplemental3',
                            '7_a_supplemental2',
                            '17_supplemental5',
                            '17_supplemental4'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false
                    }
                ],
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: 'label6',
            inputType: 'label',
            text: 'General Contractor details',
            name: 'label6',
            attributes: {
                controlGroup: 'generalContractorInfo'
            }
        },
        {
            questionId: '10_supplemental1',
            name: 'generalContractorName',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            text: 'Name of General Contractor',
            attributes: {
                controlGroup: 'generalContractorInfo'
            },
            placeholder:
                'Provide as much information as is available, you can provide full details prior to binding',
            placeholderExposed: true
        },

        {
            questionId: '10_supplemental2',
            name: 'generalLiabilityCarrier',
            inputFormat: 'text',
            inputType: 'text',
            disableOtherField: 'excessLimitAmount',
            required: false,
            text: 'Who is the GL Carrier of General Contractor?',
            attributes: {
                controlGroup: 'generalContractorInfo'
            }
        },
        {
            questionId: '10_supplemental3',
            name: 'generalContractorAmount',
            inputFormat: 'currency',
            text: 'What are the total liability limits carried by the General Contractor?',
            inputType: 'text',
            required: false,
            attributes: {
                controlGroup: 'generalContractorInfo'
            },
            helper: 'General Liability plus Excess'
        },
        {
            questionId: '11_supplemental4',
            text: 'Is there a separate egress/ingress for construction workers accessing this building? ',
            name: 'occupancyDescription',
            inputType: 'radio',
            inputFormat: 'text',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: 'Yes'
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: 'No',
                    }
                ],
                controlGroup: 'occupancyDetails',
            }
        },
        {
            questionId: '11_supplemental5',
            text: 'What percentage of the building will be occupied?',
            name: 'occupancyPercentage',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'occupancyDetails'
            }
        },
        {
            questionId: '11_supplemental3',
            text: 'How are the occupants protected from construction work/activities?',
            name: 'occupancyProtectionDescription',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'occupancyDetails'
            }
        },
        {
            questionId: '13_supplemental1',
            text: 'When did work begin?',
            name: 'workStartDate',
            inputType: 'text',
            inputFormat: 'date',
            required: false,
            attributes: {
                controlGroup: 'termDetails'
            }
        },
        {
            questionId: '13_supplemental5',
            text: 'Why has work started & stopped/why is coverage being replaced?',
            name: 'workCompleteDescription',
            inputType: 'text',
            inputFormat: 'freeform',
            required: false,
            attributes: {
                controlGroup: 'termDetails'
            }
        },
        {
            questionId: '13_supplemental6',
            text: 'Confirm details of work completed to date, including costs',
            name: 'workStartDescription',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
            attributes: {
                controlGroup: 'termDetails'
            }
        },
        {
            questionId: '13_supplemental7',
            text: 'Confirm details of work remaining, including costs',
            name: 'workRemainDescription',
            inputType: 'text',
            inputFormat: 'freeform',
            required: false,
            attributes: {
                controlGroup: 'termDetails'
            }
        },
        {
            questionId: '13_supplemental3',
            text: 'Total spent to date?',
            name: 'totalSpent',
            inputType: 'number',
            inputFormat: 'currency',
            required: false,
            attributes: {
                controlGroup: 'termDetails'
            }
        },
        {
            questionId: '13_supplemental8',
            text: 'Name of the GL carrier providing coverage for NI during prior work',
            name: 'priorworkNI',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'termDetails'
            }
        },
        {
            questionId: '13_supplemental4',
            text: 'What is the name of the GC responsible for prior work?',
            name: 'priorGcResponsible',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            attributes: {
                controlGroup: 'termDetails'
            }
        },
        {
            questionId: '15_supplemental1',
            name: 'sidewalkDetails',
            text: 'Please provide details.',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false
        },
        {
            questionId: '17_supplemental1',
            name: 'secondAdditionalInsuredName',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '17_supplemental6',
            name: 'thirdAdditionalInsuredAddress',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            helper: ' Note - Additional Insured address information is mandatory at the time of binding',
            placeholder: 'Address',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },

        {
            questionId: '17_supplemental7',
            name: 'thirdAdditionalInsuredCity',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            inlineItem: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },

        {
            questionId: '17_supplemental8',
            name: 'thirdAdditionalInsuredState',
            inputType: 'dropdown-single',
            required: false,
            inlineItem: true,
            placeholder: 'State',
            attributes: {
                options: statesArray,
                controlGroup: 'additionalInsuredInfo'
            }
        },

        {
            questionId: '17_supplemental9',
            name: 'secondAdditionalInsuredZipCode',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            inlineItemZip: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '17_supplemental2',
            name: 'secondAdditionalInsuredRelationship',
            inputType: 'dropdown-single',
            required: true,
            inlineItem: true,
            containRelationForms: 'Forms2',
            placeholder: 'Relationship To Primary',
            attributes: {
                options: roleArrayValidation('14_supplemental2a'),
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '7_a_supplemental2',
            text: 'Does the lender need to be specifically named?',
            name: 'secondBanksMortgagees',
            inputType: 'radio',
            placeholder:
                'Blanket CG2018 is included for lenders. AP is $250 per Named Bank form.',
            placeholderExposed: true,
            tooltiptext: 'Please choose if you need to name the bank.',
            required: true,
            hideKey: 'Forms2',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ],
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '17_supplemental5',
            text: 'List all forms needed:',
            name: 'secondAdditionalInsuredForms',
            inputFormat: 'radio',
            inputType: 'dropdown-multiselectcheckbox',
            required: false,
            conditionalText: '*Condition to Underwriter Approval',
            formsList: 'Forms2',
            attributes: {
                options: FormsList,
                controlGroup: 'additionalInsuredInfo'
            },
        },
        {
            questionId: '17_supplemental4',
            text: 'Any other Additional Insured?',
            name: 'secondAdditionalInsuredOther',
            inputFormat: 'radio',
            inputType: 'radio',
            required: true,
            thirdLevelSupplementQuesId: ['7_a_supplemental3', '21_supplemental2a'],
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                        supplementalquestionIds: [
                            '19_supplemental1',
                            '19_supplemental6',
                            '19_supplemental7',
                            '19_supplemental8',
                            '19_supplemental9',
                            '19_supplemental2',
                            '19_supplemental3',
                            '7_a_supplemental3',
                            '19_supplemental5',
                            '19_supplemental4'
                        ]
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ],
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '19_supplemental1',
            name: 'thirdAdditionalInsuredName',
            inputFormat: 'text',
            inputType: 'text',
            required: true,
            placeholder: 'Name',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '19_supplemental6',
            name: 'thirdAdditionalInsuredAddress',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            helper: ' Note - Additional Insured address information is mandatory at the time of binding',
            placeholder: 'Address',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },

        {
            questionId: '19_supplemental7',
            name: 'thirdAdditionalInsuredCity',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            inlineItem: true,
            placeholder: 'City',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },

        {
            questionId: '19_supplemental8',
            name: 'thirdAdditionalInsuredState',
            inputType: 'dropdown-single',
            required: false,
            inlineItem: true,
            placeholder: 'State',
            attributes: {
                options: statesArray,
                controlGroup: 'additionalInsuredInfo'
            }
        },

        {
            questionId: '19_supplemental9',
            name: 'thirdAdditionalInsuredZipCode',
            inputType: 'text',
            inputFormat: 'text',
            required: false,
            inlineItemZip: true,
            placeholder: 'Zip Code',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '19_supplemental2',
            name: 'thirdAdditionalInsuredRelationship',
            inputType: 'dropdown-single',
            required: true,
            inlineItem: true,
            containRelationForms: 'Forms3',
            placeholder: 'Relationship To Primary',
            attributes: {
                options: roleArrayValidation('21_supplemental2a'),
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '7_a_supplemental3',
            text: 'Does the lender need to be specifically named?',
            name: 'thirdBanksMortgagees',
            inputType: 'radio',
            placeholder:
                'Blanket CG2018 is included for lenders. AP is $250 per Named Bank form.',
            placeholderExposed: true,
            tooltiptext: 'Please choose if you need to name the bank.',
            required: true,
            hideKey: 'Forms3',
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                        supplementalquestionIds: []
                    }
                ],
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '19_supplemental5',
            text: 'List all forms needed:',
            name: 'thirdAdditionalInsuredForms',
            inputFormat: 'radio',
            inputType: 'dropdown-multiselectcheckbox',
            required: false,
            formsList: 'Forms3',
            conditionalText: '*Condition to Underwriter Approval',
            attributes: {
                options: FormsList,
                controlGroup: 'additionalInsuredInfo'
            },
        },
        {
            questionId: '18_supplemental2a',
            name: 'additionalInsuredRelationshipOther',
            inputFormat: 'text',
            inputType: 'text',
            placeholder: 'Relationship',
            placeholderOnly: true,
            hideKey: 'Relation1',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '14_supplemental2a',
            name: 'secondAdditionalInsuredRelationshipOther',
            inputFormat: 'text',
            inputType: 'text',
            placeholder: 'Relationship',
            placeholderOnly: true,
            hideKey: 'Relation2',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '21_supplemental2a',
            name: 'thirdAdditionalInsuredRelationshipOther',
            inputFormat: 'text',
            inputType: 'text',
            placeholder: 'Relationship',
            placeholderOnly: true,
            hideKey: 'Relation3',
            attributes: {
                controlGroup: 'additionalInsuredInfo'
            }
        },
        {
            questionId: '32_supplemental1',
            name: 'otherSubcontractors',
            text: 'Please provide a list of such contractors.',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false
        },
        {
            questionId: '997_supplemental1',
            name: 'demolitionDetailsContractor',
            text: 'What is the name of the demolition contractor being hired?',
            inputFormat: 'text',
            inputType: 'text',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '997_supplemental2',
            name: 'demolitionDetailsGCOwner',
            text: 'Who is hiring the demolition contractor, the General Contractor, or the Owner',
            inputType: 'radio',
            inputFormat: 'radio',
            required: true,
            placeholder: 'Please note that if this information changes, the pricing you receive is no longer valid and the account must be re-rated.',
            placeholderExposed: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'General Contractor',
                        value: true,
                    },
                    {
                        optionId: '2',
                        text: 'Owner',
                        value: false,
                    }
                ],
                controlGroup: 'exteriorDemo'
            },
        },
        {
            questionId: '997_supplemental3',
            name: 'demolitionDetailsCost',
            text: 'Total Demolition Cost',
            inputFormat: 'currency',
            inputType: 'text',
            required: true,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '997_supplemental4',
            name: 'demolitionDetailsInterior',
            text: 'Is the demo work being performed interior only?',
            inputType: 'radio',
            inputFormat: 'radio',
            required: true,
            attributes: {
                options: [
                    {
                        optionId: '1',
                        text: 'Yes',
                        value: true,
                    },
                    {
                        optionId: '2',
                        text: 'No',
                        value: false,
                    }
                ],
                controlGroup: 'exteriorDemo'
            },
        },
        {
            questionId: '997_supplemental5',
            name: 'demolitionDetailsStories',
            text: 'Total # of stories being demolished?',
            inputFormat: 'number',
            inputType: 'text',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '997_supplemental6',
            name: 'demolitionDetailsMethod',
            text: 'Describe methods used for demolition (any use of ball & chain or blasting)?',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '997_supplemental7',
            name: 'demolitionDetailsMonths',
            text: 'How many months will demolition take?',
            inputFormat: 'number',
            inputType: 'text',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
        {
            questionId: '997_supplemental8',
            name: 'demolitionDetailsPrecautions',
            text: 'Describe the safety precautions in place to protect pedestrians & workers',
            inputFormat: 'text',
            inputType: 'freeform',
            required: false,
            attributes: {
                controlGroup: 'exteriorDemo'
            }
        },
    ]
};

export default updatedData;
